module.exports = "<!-- View/routes wrapper-->\r\n<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common/layouts/blankLayout.template.html
// module id = 1091
// module chunks = 0